<template>
    <md-list-item
        class="ql-marker-nav-item"
        :class="navItemClasses"
        @click.native="gotoPage"
    >
        <div class="ql-marker-nav-row">
            <bookmark-type-icon :type="marker.type" class="ql-marker-nav-icon" />
            <span class="ql-marker-nav-text">
                <span class="ql-marker-nav-page">p {{ pageName }}</span>
                <span class="ql-marker-nav-label">{{ displayLabel }}</span>
            </span>
        </div>
    </md-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import { sidebarMarkerRowText } from '@/lib/marker-labels';
import BookmarkTypeIcon from '@/components/project/bookmark/bookmark-type-icon';

export default {
    name: 'MarkerNavItem',
    components: {
        'bookmark-type-icon': BookmarkTypeIcon
    },
    props: {
        marker: { type: Object, required: true },
        currentPage: { type: Number, default: 1 }
    },
    computed: {
        ...mapGetters(['project']),
        displayLabel() {
            return sidebarMarkerRowText(this.marker);
        },
        pageName() {
            const pages = this.project && this.project.pdfPageNumbers;
            const idx = Number(this.marker.pageIndex) - 1;
            if (pages && pages[idx] && pages[idx].name) {
                return pages[idx].name;
            }
            return this.marker.pageIndex;
        },
        navItemClasses() {
            const type = this.marker.type || 'scene';
            return {
                'ql-marker-nav-act': type === 'act',
                'ql-marker-nav-nested': type === 'scene' || type === 'song',
                'ql-marker-nav-current': Number(this.marker.pageIndex) === Number(this.currentPage)
            };
        }
    },
    methods: {
        gotoPage() {
            this.$emit('gotoPage', Number(this.marker.pageIndex));
        }
    }
};
</script>

<style lang="scss">
.ql-marker-nav-item {
    cursor: pointer;
    min-height: 32px;
    font-weight: 400;

    .md-list-item-container {
        padding: 6px 16px 6px 12px;
        font-weight: 400;
    }

    &.ql-marker-nav-act .ql-marker-nav-row {
        border-bottom: 1px solid #bdbdbd;
        padding-bottom: 6px;
    }

    &.ql-marker-nav-act .ql-marker-nav-label {
        font-weight: 600;
    }

    &.ql-marker-nav-nested .md-list-item-container {
        padding-left: 32px;
    }

    &.ql-marker-nav-current {
        background: #f5f5f5;
    }

    &:hover {
        background: #eee;
    }
}

.md-theme-show-mode .ql-marker-nav-item {
    &.ql-marker-nav-current {
        background: rgba(255, 255, 255, 0.08);
    }

    &:hover {
        background: #333;
    }

    &.ql-marker-nav-act .ql-marker-nav-row {
        border-bottom-color: rgba(255, 255, 255, 0.2);
    }

    .ql-marker-nav-icon {
        color: #fff;
    }

    .ql-marker-nav-text,
    .ql-marker-nav-page,
    .ql-marker-nav-label {
        color: rgba(255, 255, 255, 0.9);
    }
}

.ql-marker-nav-row {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.ql-marker-nav-icon {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    color: #222;
}

.ql-marker-nav-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.35;
    color: #222;
}

.ql-marker-nav-page {
    margin-right: 6px;
    font-weight: 400;
    color: #222;
}

.ql-marker-nav-label {
    font-weight: 400;
    color: #222;
}
</style>



// WEBPACK FOOTER //
// marker-nav-item.vue?13b34bbf